export default function handleFileUploadAttempt({
  fileForm,
  fileInputName,
  fileType,
  fileSize,
  uploadCallback,
  fileTooLargeHandler,
  wrongFileTypeHandler,
}) {
  const MAX_SIZE = 15728640
  const data = new FormData(fileForm)
  const file = data.get(fileInputName)
  if (!fileType.startsWith('image/') || fileSize === 0) {
    wrongFileTypeHandler()
  } else if (fileSize > MAX_SIZE) {
    fileTooLargeHandler()
  } else {
    uploadCallback(file)
  }

  fileForm.reset()
}
